export default __webpack_public_path__ + "static/media/life.0008a703.svg";